import type { FC } from 'react';
import {
  alpha,
  Box,
  Container,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography
} from '@mui/material';
import MinusIcon from '../res/icons/Minus';
import Logo from './Logo';
import {LINK_COOKIE_POLICY, LINK_PRIVACY, LINK_TERMS} from "../constants";

const sections = [
  {
    title: 'General',
    links: [
      {
        title: 'Privacy Policy',
        href: LINK_PRIVACY
      },
      {
        title: 'Cookie policy',
        href: LINK_COOKIE_POLICY
      },
      {
        title: 'Terms',
        href: LINK_TERMS
      },
      {
        title: 'F.A.Q',
        href: '/faq'
      },
      {
        title: 'Contatti',
        href: '/contact'
      }
    ]
  },
  {
    title: 'Social',
    links: [
      {
        title: 'Facebook',
        href: 'https://www.facebook.com/MicroMega.net'
      },
      {
        title: 'Instagram',
        href: 'https://www.instagram.com/micromega_rivista/'
      },
      {
        title: 'Twitter',
        href: 'https://twitter.com/_MicroMega_'
      },
      {
        title: 'Youtube',
        href: "https://www.youtube.com/c/redazioneMicroMega"
      }
    ]
  }
];

const Footer: FC = (props) => (
  <Box
    sx={{
      backgroundColor: 'background.default',
      pb: 6,
      pt: {
        md: 15,
        xs: 6
      }
    }}
    {...props}
  >
    <Container maxWidth="lg">
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          md={3}
          sm={4}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            order: {
              md: 1,
              xs: 4
            }
          }}
          xs={12}
        >
          <Logo />
          <Typography
            color="textSecondary"
            sx={{ mt: 2 }}
            variant="caption"
          >
            © 2021 Micromega. All Rights Reserved.
          </Typography>

          <Typography
              color="textSecondary"
              sx={{ mt: 1 }}
              variant="caption">
            <p>Direttore responsabile: Paolo Flores d’Arcais</p>
            <p>Edito da Micromega Edizioni impresa sociale SRL</p>
            <p>P.Iva 15971151004</p>
            <p>Pec editore@pec.micromegaedizioni.net</p>
            <p>Registrazione nr. 117/86</p>
            <p>Presso il Tribunale di Roma</p>
            <p>ISSN 2282-121X</p>
          </Typography>
        </Grid>
        {sections.map((section, index) => (
          <Grid
            item
            key={section.title}
            md={3}
            sm={4}
            sx={{
              order: {
                md: index + 2,
                xs: index + 1
              }
            }}
            xs={12}
          >
            <Typography
              color="textSecondary"
              variant="overline"
            >
              {section.title}
            </Typography>
            <List disablePadding>
              {section.links.map((link) => (
                <ListItem
                  disableGutters
                  key={link.title}
                  sx={{
                    pb: 0,
                    pt: 1
                  }}
                >
                  <ListItemAvatar
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      minWidth: 0,
                      mr: 0.5
                    }}
                  >
                    <MinusIcon color="primary" />
                  </ListItemAvatar>
                  <ListItemText
                    primary={(
                      <Link
                        href={link.href}
                        color="textPrimary"
                        variant="subtitle2"
                      >
                        {link.title}
                      </Link>
                    )}
                  />
                </ListItem>
              ))}
            </List>
          </Grid>
        ))}
      </Grid>
      <Divider
        sx={{
          borderColor: (theme) => alpha(theme.palette.primary.contrastText, 0.12),
          my: 6
        }}
      />

    </Container>
  </Box>
);

export default Footer;
